import $ from 'jquery';

$(function() {
    $('#cwm-user-name').text($('#currentUser').val());  
  });


// WEBPACK FOOTER //
// ./components/cwm-custom-scripts/cwm-hero-personalisation.js